module.exports = __webpack_public_path__ + "static/media/sdc-header.f3472028.png";